import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from 'src/app/utils/utils.service';
import { GisMapComponent } from '../gis-map/gis-map.component';
import * as d3 from 'd3';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isNullOrUndefined } from 'util';
import { CdkDragDrop, CdkDragStart } from '@angular/cdk/drag-drop';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertDataService } from '../../side-bar/alert/alert-data.service';

@Component({
  selector: 'app-bottombar-menu',
  templateUrl: './bottombar-menu.component.html',
  styleUrls: ['./bottombar-menu.component.scss']
})
export class BottombarMenuComponent implements OnInit {

  
  playpause: boolean;
  startIndex = 0;
  state = 'stop';
  timeArray = ProjConstants.SIXHOURBLOCKS;
  currentComponent;
  bottomBarOpen = false;
  measurementControl: any
  measureArea : any 
  measureDistance: any ;
  measureType : any  
  urlParams : any;
  visibleShape : any
  @Input() mapObj :any ;
  @Input() layersList : any;
  @Input() activeLayers : any ;
  @Input() gisMapComp;
  mitanksToolCloseSubscription:Subscription;
  modalRef: any;
  @ViewChild("DragHeader" , {
    read: ElementRef,
    static: false
  }) public dragHeader : ElementRef;
  @ViewChild("bottomBarContainer" , {
    read: ElementRef,
    static: false
  }) public bottomBarContainer : ElementRef;
  mitanksEditingSrv: any;
  constructor(private gisUtils : AlertDataService,private modalService : NgbModal,private renderer: Renderer2) {
   }

  menus = [
    {title:"Base Layers", icon:"fa fa-lg fa-th-large m-2"},
    // {title:"Layers", icon:"tnw-layers"},
    // {title:"Legend", icon:"tnw-legend-01"},
    // {title:"Measure", icon:"tnw-measure"},
    // {title:"Draw Tool", icon:"tnw-art"}
  ];


  
  ngOnInit() {  
    this.subscribeEvents();
} 
ngAfterViewInit(): void {
  if (this.bottomBarContainer) {
    this.renderer.listen(this.bottomBarContainer.nativeElement, 'wheel', (event) => {
      event.stopPropagation();
    });
  } else {
    console.error('bottomBarContainer is not defined.');
  }
}

onDragStarted(event: CdkDragStart): void {
  this.mapObj.dragging.disable();
}


onDragDropped(event: CdkDragDrop<any>): void {
  this.mapObj.dragging.enable();
}


changeComponents(component, close?) {    
  // if (this.currentComponent == component) {
  //   this.currentComponent = null;
  //   this.bottomBarOpen = !this.bottomBarOpen;
  // }
  // else {
  //   this.currentComponent = component;
  //   this.bottomBarOpen = false;
  // }
      this.mapObj.dragging.enable();
    
  if (this.currentComponent == component) {
    this.currentComponent = null;
    this.bottomBarOpen = !this.bottomBarOpen;
  }
  else {
    this.currentComponent = component;
    this.bottomBarOpen = false;
  }
  if(!isNullOrUndefined(this.visibleShape))
  this.clearDrawToolShapes();

  if (this.currentComponent === 'Measure' && close) {
    if (close === true && this.measurementControl)
      this.measurementControl.stopMeasuring()

    this.measureArea = null;
    this.measureDistance = null;
    this.measureType = null;
  }
  if(this.currentComponent === 'Draw Tool'){
    if(!isNullOrUndefined(this.visibleShape))
    this.clearDrawToolShapes();  }
  // if(component == 'Compare'){
  //   let compareParams={...this.urlParams}
  //   compareParams['pUUID']=ProjConstants.STATETOUUIDMAPPING.TAMILNADU;
  //   compareParams['pType']='STATE';
  //   compareParams['cType']='DISTRICT';
  //   compareParams['actionType']='filter';
  //   compareParams['year']='2022-2023';
  //   compareParams['locName']='TAMILNADU';
  //   this.gisUtils.setToggleGWMSLayer({});
  //   this.gisUtils.setGwmsData(compareParams);
  //     this.modalRef = this.modalService.open(MapcompareComponent, {
  //       backdrop: 'static',
  //       windowClass: 'backgroundTransparent fullscreen'
  //     });
  // }
}
revalidateMap() {
  if (this.mapObj) {
    this.mapObj.invalidateSize();
    this.mapObj.fire('zoomend');
  }
  this.mapObj.dragging.enable();

}

clearDrawToolShapes() {
  for (const shape of this.visibleShape) {
    if (shape) {
      shape.shape.remove();
      if (shape.text) { shape.text.remove(); }
    }
  }
  // this.mapObj.off('mousedown');
  // this.mapObj.off('mousemove');
  // this.mapObj.off('mouseup');

}

removeControl(event) {
  this.measurementControl = event.measureControl;
  this.measureType = event.measureType;
  this.measureArea = event.measureArea;
  this.measureDistance = event.measureDistance;
}
removeShapes(event) {
  this.visibleShape = event.visibleShapes;
}


subscribeEvents(){

  this.gisUtils.getSelectedParams().subscribe(params => {
    this.urlParams = params;
    // let isMitanksToolPresent = this.menus.some(obj => obj.title === 'Mitanks Tool');

    // if(this.urlParams['component'] == 'WATER_SPREAD' || (this.urlParams['component'] == 'MITANK' && this.checkIfParentLevelOfMitanks())){
    //   if(!isMitanksToolPresent)
    //     this.menus.push(this.mitanksToolObj);
    // }
    // else{
    //   if(isMitanksToolPresent){
    //     const index = this.menus.indexOf(this.mitanksToolObj);
    //     if (index !== -1) {
    //         this.menus.splice(index, 1);
    //     }        
    //   }
    // }
  });

}

checkIfParentLevelOfMitanks(){

  let mitanksIndex = this.urlParams['locationTypeList'].indexOf("MITANK");

  if(mitanksIndex != -1 && (this.urlParams['locationTypeList'][mitanksIndex-1] == this.urlParams['pType'] || this.urlParams['locationTypeList'][mitanksIndex] == this.urlParams['pType']))
      return true;
  else
      return false;

}

}
